import { AuthorizationPdfParams, Dates, Translations, Language } from "@salaxy/core";
import { HeaderFooterData, ReportOptions, ReportLayout } from "../../model";


/**
 * Mapper for authorization.
 */
export class AuthorizationMapper {

  /**
   * Loads report type specific HeaderFooterData.
   * @param reportOptions The AuthorizationPdf entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  public static getHeaderFooter(reportOptions: ReportOptions, lang: Language): HeaderFooterData {
    const headerFooter: HeaderFooterData = {
      logo: reportOptions?.logo,
      img2: reportOptions?.img2,
      title: Translations.get("SALAXY.REPORTS.authorization.heading.title", null, lang).toUpperCase(),
      today: Dates.getFormattedDate(Dates.getToday()),
      date: Dates.getFormattedDate(Dates.getToday())
    };
    return headerFooter;
  }

  /**
   * Loads report type specific HeaderFooterData.
   * @param reportOptions The AuthorizationPdf entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
   public static getRaksaHeaderFooter(reportOptions: ReportOptions, lang: Language): HeaderFooterData {
    const headerFooter: HeaderFooterData = {
      logo: reportOptions?.logo,
      img2: reportOptions?.img2,
      title: Translations.get("Palkkamyllyn valtakirja", null, lang).toUpperCase(),
      today: Dates.getFormattedDate(Dates.getToday()),
      date: Dates.getFormattedDate(Dates.getToday())
    };
    return headerFooter;
  }

  /**
   * Loads report type specific HeaderFooterData.
   * @param reportOptions The AuthorizationPdf entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  public static getKycHeaderFooter(reportOptions: ReportOptions, lang: Language): HeaderFooterData {
    const headerFooter: HeaderFooterData = {
      logo: reportOptions?.logo,
      img2: reportOptions?.img2,
      title: Translations.get("SALAXY.REPORTS.kycCompany.heading", null, lang).toUpperCase(),
      today: Dates.getFormattedDate(Dates.getToday()),
      date: Dates.getFormattedDate(Dates.getToday())
    };
    return headerFooter;
  }

  /**
   * Loads the raw report that is then rendered downstream as an html or pdf report. Also handles if person or company
   * @param businessObject Authorization entity
   * @returns Authorization
   */
  public static getAuthorizationReport(businessObject: AuthorizationPdfParams): AuthorizationPdfParams {
    return businessObject;
  }

  /**
   * Loads the authorization layout for pdf or html reports.
   * @param pdf Are we rendering a pdf report or not.
   * @returns Returns authorization layout.
   */
  public static loadReportLayout(pdf: boolean): ReportLayout {
    const reportLayout: ReportLayout = {
     isLayoutA4Portrait: true,
     isLayoutA4Landscape: false,
     layout: "a4Portrait",
     date: Dates.getFormattedDate(Dates.getToday()),
     isPreview: false,
     mode: pdf ? "pdf" : "htmlPage",
     isModeHtmlPage: !pdf,
     isModePdf: pdf,
    };
   return reportLayout;
 }

}